import React from "react";
import { Box, Stack, Typography, Paper } from "@mui/material";

export default function PokimanePage() {
  return (
    <Box>
      {/* Page header — matches OC's standard layout (h1 serif title + secondary subtitle) */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "flex-start" }}
        spacing={{ xs: 1.5, sm: 0 }}
        sx={{ mb: { xs: 2, md: 3.5 } }}
      >
        <Box>
          <Typography variant="h1" sx={{ mb: 0.5, fontSize: { xs: "1.85rem", md: "2.5rem" } }}>
            Pokiqueen
          </Typography>
          <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
            A small tribute.
          </Typography>
        </Box>
      </Stack>

      <Paper
        variant="outlined"
        sx={{
          p: { xs: 2, md: 3 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src="/pokimane.png"
          alt="Pokiqueen"
          sx={{
            width: { xs: "80%", sm: "60%", md: "40%" },
            height: "auto",
            display: "block",
            borderRadius: 1,
          }}
        />
      </Paper>
    </Box>
  );
}
